export default "__VITE_ASSET__1tlvPXA8__"